import * as React from 'react';
import { observer } from 'mobx-react';
import { OwaDate } from 'owa-datetime';
import { DropdownDatePicker } from 'owa-datepicker';
import DateRange from '../store/schema/DateRange';
import endOfDay from 'owa-datetime/lib/owaDate/endOfDay';
import startOfDay from 'owa-datetime/lib/owaDate/startOfDay';
import strings from 'owa-strings/owa-mail-strings';
import today from 'owa-datetime/lib/userDate/today';

export interface RangeDatePickerProps extends React.HTMLAttributes<HTMLDivElement> {
    onDateRangeSelected: (dateRange: DateRange) => void;
    /** if the dateRange prop is utilized then the consumer is responsible for maintaining the
     * component's date range state, otherwise the date range is managed using component state
     */
    dateRange?: DateRange;
    defaultSelectedRange?: DateRange;
    className?: string;
}

const styles = require('./RangeDatePicker.scss');

@observer
export default class RangeDatePicker extends React.Component<RangeDatePickerProps, DateRange> {
    constructor(props: RangeDatePickerProps) {
        super(props);
        const todayDate = today();
        this.state = this.props.defaultSelectedRange
            ? {
                  startDate: this.props.defaultSelectedRange.startDate,
                  endDate: this.props.defaultSelectedRange.endDate,
              }
            : {
                  startDate: todayDate,
                  endDate: endOfDay(todayDate),
              };
    }

    render() {
        const { startDate, endDate } = this.props.dateRange ? this.props.dateRange : this.state;
        const todayDate = today();

        return (
            <div className={this.props.className || styles.dateFilterContent}>
                <DropdownDatePicker
                    label={strings.fromPeopleRefinerTitle}
                    onSelectDate={this.onFromDateSelected}
                    value={startDate}
                    maxDate={todayDate}
                    className={styles.topDatePicker}
                />

                <DropdownDatePicker
                    label={strings.toPeopleRefinerTitle}
                    onSelectDate={this.onToDateSelected}
                    minDate={startDate}
                    maxDate={todayDate}
                    value={endDate}
                />
            </div>
        );
    }

    private onFromDateSelected = (date: OwaDate) => {
        let { endDate } = this.props.dateRange ? this.props.dateRange : this.state;
        let startDate = startOfDay(date);
        if (endDate < startDate) {
            endDate = null;
        }
        this.props.onDateRangeSelected({
            startDate: startDate,
            endDate: endDate,
        });
        this.setState({ startDate: startDate, endDate: endDate });
    };

    private onToDateSelected = (date: OwaDate) => {
        // set the time to the end of the day
        let { startDate } = this.props.dateRange ? this.props.dateRange : this.state;

        let endDate = endOfDay(date);
        this.props.onDateRangeSelected({
            startDate: startDate,
            endDate: endDate,
        });
        this.setState({ endDate: endDate });
    };
}
